<template>
  <div class="third">
    <div class="third-formOne import-pub">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>
          <span class="left-back-content">服务配置》{{currentName}}</span>
        </div>
        <div class="btn-right">
          <el-button @click="resetForm" class="btn-two" type="default">重置</el-button>
          <el-button @click="commit" class="btn-two" type="primary" v-el-disabel-repeat-click>保存</el-button>
        </div>
      </div>
      <el-form
        @validate="validateValue"
        :show-message="false"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="86px"
      >
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px;">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">基本信息</span>
              </div>
            </div>
            <div class="one-list">
              <el-form-item label="卡片展示名称" prop="showName">
                <el-input
                  class="list-input"
                  :maxlength="8"
                  v-model.trim="ruleForm.showName"
                  placeholder="请输入"
                ></el-input>
                <span></span>
              </el-form-item>
              <el-form-item label="卡片顺序" prop="orderNum">
                <el-input
                  class="list-input"
                  :maxlength="2"
                  v-model.trim="ruleForm.orderNum"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="首页展示" prop="homeRow">
                <el-radio-group v-model="ruleForm.homeRow">
                  <el-radio :label="1">一行</el-radio>
                  <el-radio :label="2">两行</el-radio>
                  <el-radio :label="3">三行</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <preview-modal
      :previewModal="dialogVisible"
      :previewImageUrl="dialogImageUrl"
      @previewClose="closePreview"
    ></preview-modal>
  </div>
</template>

<script>
import { upicon, add } from "@/api/slidenshow/slidenshow";
import { itemDetailPort, updatePort} from '@/api/appSetting/appServiceSetting'

export default {
  name: "formSeven",
  props: ['rowId'],
  data() {
    const blurText = async (rule, value, callback) => {
      const boolean = new RegExp("^[1-9][0-9]*$").test(value); // console.log(boolean)
      if (!boolean) {
        callback(new Error("请输入正整数"));
      }
    };
    return {
      cpRowId: this.rowId,
      currentName:'',
      countNum: 1, //用于显示第一个错误
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [
        // {
        //   name: "food.jpeg",
        //   url:
        //     "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100"
        // },
        // {
        //   name: "food2.jpeg",
        //   url:
        //     "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100"
        // }
      ], // 上传文件列表
      pointList: [],
      rules: {
        orderNum: [
          { required: true, message: "请输入卡片顺序", trigger: "blur" },
          { validator: blurText, trigger: "blur" } //表单验证的时候会调用的方法
        ],
        showName: [{ required: true, message: "请输入展示名称", trigger: "blur" }],
        homeRow: [{ required: true, message: "请选择首页展示", trigger: "change" }]
      },
      ruleForm: {
        id: "",
        showName: '',
        orderNum: '',
        homeRow: 1,
      },
      uploadFilter: ['.jpg', '.jpeg', '.png'],
      canAdd: true, // 是否可以新增
    };
  },
  watch: {
    rowId() {
      this.cpRowId = this.rowId
    }
  },
  created() {
    this.itemDetail()
  },
  methods: {
    async itemDetail () {
      console.log('this.cpRowId', this.cpRowId)
      const {
        data: {
          result, msg, status
        }
      } = await itemDetailPort({
        id: this.cpRowId
      })
      if (status === 1000) {
        this.currentName = result.itemName
        this.ruleForm = result
        console.log('结果', result)
        return
      }
      return this.$message.error(msg)
    },
    async updateData () {
      console.log('this.cpRowId', this.cpRowId)
      const {
        data: {
          result, msg, status
        }
      } = await updatePort({
        ...this.ruleForm
      })
      if (status === 1000) {
        this.$message.success('操作成功')
        this.goBack()
        console.log('结果', result)
        return
      }
      return this.$message.error(msg)
    },
    goBack() {
      this.$emit("changeComponent",'homePage');
    },
    // 提交表单
    commit() {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.ruleForm.validate(valid => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            this.updateData()
          } else {
            return false;
          }
        });
      });
    },
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //新增/修改学校信息
    save() {
      this.canAdd = false
      try {
        let id = null;
        if (this.ID == null) {
          id = 0;
        } else {
          id = this.ruleForm.id;
        }
        // let sort = Number(this.ruleForm.sort)
        const params = {
          id: id, //轮播图ID  新增时为-1或者0
          sort: this.ruleForm.sort, //行序序号
          title: this.ruleForm.title, //标题
          imgUrl: this.ruleForm.imgUrl, //图片地址
          detailUrl: this.ruleForm.detailUrl, //网址
          stopTime: this.ruleForm.stopTime, //自动停用时间
          status: this.ruleForm.status //轮播图状态 1启用 0停用
        };
        add(params).then(res => {
          const data = res.data;
          console.log("这是轮播图新增/编辑接口", data);
          if (data.status === 1000) {
            this.$message.success("保存成功");
            this.canAdd = true
            this.goBack();
          } else {
            this.canAdd = true
            this.$message.error(data.msg);
          }
        });
      } catch (err) {
        this.canAdd = true
        this.$message.error(err);
        console.log(err);
      }
    },
    //表单验证
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //表单重置
    resetForm(formName) {
      this.$refs.ruleForm.clearValidate()
      this.$nextTick(() => {
        this.itemDetail()
      })
    },
    //关闭预览弹窗
    closePreview() {
      this.dialogVisible = false;
    },
    //行政区域选中节点
    handleChange(value) {
      console.log(value);
    }
  }
};
</script>

<style lang="scss">
.import-pub {
    height: 100vh !important;
  .fileDisabled {
    .el-upload--picture-card {
      display: none;
    }
  }
}
</style>
